import { PostType, PostTypeProps } from 'types/marketplace/community';

// PostType과 PostTypeProps 속성 매핑 객체
const POST_TYPE_MAPPING = {
  [PostType.BANNER]: 'banner',
  [PostType.PIN]: 'topicPin',
  [PostType.PIN_ALL_TOPICS]: 'allTopicPin',
} as const;

/**
 * PostType enum 값에 따라 PostTypeProps 객체에서 해당하는 boolean 값을 반환
 * @param postType - PostType enum 값
 * @param postTypeProps - PostTypeProps 객체
 * @returns boolean - 해당 postType이 활성화되어 있는지 여부
 */
export const getIsPostTypeChecked = (postType: PostType, postTypeProps: PostTypeProps): boolean => {
  const propertyKey = POST_TYPE_MAPPING[postType];
  return propertyKey ? (postTypeProps[propertyKey] || false) : false;
};


/**
 * PostType 배열을 PostTypeProps 객체로 변환
 * @param postTypeArray - PostType enum 값들의 배열
 * @returns PostTypeProps - PostTypeProps 객체
 */
export const getPostTypesObject = (postTypeArray: number[]): PostTypeProps => {
  return Object.entries(POST_TYPE_MAPPING).reduce((acc, [postTypeValue, propertyKey]) => {
    acc[propertyKey] = postTypeArray.includes(Number(postTypeValue));
    return acc;
  }, {} as PostTypeProps);
};

/**
 * PostTypeProps 객체에서 활성화된 항목의 개수를 반환
 * @param postTypeProps - PostTypeProps 객체
 * @returns number - 활성화된 항목의 개수
 */
export const getPostTypesCount = (postTypeProps: PostTypeProps): number => {
  return Object.values(POST_TYPE_MAPPING)
    .filter(propertyKey => postTypeProps[propertyKey])
    .length;
};

/**
 * PostTypeProps 객체를 PostType 배열로 변환
 * @param postTypeProps - PostTypeProps 객체
 * @returns string[] - 활성화된 PostType enum 값들의 배열 (원시 문자열 값)
 */
export const getPostTypesArray = (postTypeProps: PostTypeProps): string[] => {
  return Object.entries(POST_TYPE_MAPPING)
    .filter(([_, propertyKey]) => postTypeProps[propertyKey])
    .map(([postTypeValue]) => postTypeValue);
};
